<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";
/**
 * Invoice-detail component
 */
export default {
  page: {
    title: "Customer Balance Details",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      current_date: moment(new Date()).format("YYYY-MM-DD"),
      totals: {
        totalin: 0,
        totalout: 0,
      },
      filterRecords: {
        id: atob(this.$route.params.id),
        datefrom: atob(this.$route.params.datefrom),
        dateto: atob(this.$route.params.dateto),
      },
    };
  },
  computed: {
    ...mapGetters("customers", [
      "CustomerBalanceDetails"
    ]),
  },
  methods: {
    ...mapActions({
      FetchBalanceDetails: "customers/fetchCustomerBalanceDetails",
    }),
  },

  watch: {
    CustomerBalanceDetails(newValue) {
      if (newValue == true) {
        this.FetchBalanceDetails(this.filterRecords);
      }
    }
  },

  updated() {
    let total_in = 0;
    let total_out = 0;
    if (this.CustomerBalanceDetails) {
      this.CustomerBalanceDetails.forEach((item) => {
        total_in = total_in + parseInt(item.amount);
      });
      this.totals.totalin = total_in;
      this.CustomerBalanceDetails.forEach((item) => {
        total_out = total_out + parseInt(item.amountOut);
      });
      this.totals.totalout = total_out;

      setTimeout(() => {
        window.onafterprint = window.close;
        window.print();
        window.history.back();
      }, 2000)
    }
  },
  created() {
    this.FetchBalanceDetails(this.filterRecords);
  },
};
</script>

<style scoped>
.print-font {
  font-family: Courier New, Courier, Lucida Sans Typewriter, Lucida Typewriter, monospace;
}
</style>

<template>
  <Layout>

    <div class="row">
      <div class="col-12">

        <div class="bg-white p-2 print-font">

          <!-- LOADER -->
          <div v-if="!CustomerBalanceDetails" class="text-center py-4">
            <b-spinner variant="primary"></b-spinner>
          </div>

          <div v-else>

            <!-- BUSINESS HEADER -->
            <div class="row text-center">

              <div class="col-12">

                <img v-if="CustomerBalanceDetails[0].business2.Businesslogo"
                  :src="CustomerBalanceDetails[0].business2.Businesslogo" height="80" />

                <h3 class="text-uppercase mt-2">
                  {{ CustomerBalanceDetails[0].business2.name }}
                </h3>

                <p class="mb-1">

                  <strong>Location:</strong>
                  {{ CustomerBalanceDetails[0].business2.address }}

                  <br>

                  <strong>Tel:</strong>
                  +256{{ CustomerBalanceDetails[0].business2.phone1 }}

                  <br>

                  <strong>Email:</strong>
                  {{ CustomerBalanceDetails[0].business2.email }}

                </p>

              </div>

            </div>

            <hr style="border-style:dashed;width:97%">

            <!-- REPORT TITLE -->

            <div class="row text-center">

              <div class="col-12">

                <h5 style="font-size:22px;font-weight:bold">

                  <strong v-if="filterRecords.datefrom == 'null'">

                    CUSTOMER LEDGER FOR
                    {{ CustomerBalanceDetails[0].customer.name.toUpperCase() }}
                    -
                    {{ CustomerBalanceDetails[0].customer.contact }}

                    <br>

                    AS OF {{ current_date }}

                  </strong>

                  <strong v-else>

                    CUSTOMER LEDGER FOR
                    {{ CustomerBalanceDetails[0].customer.name.toUpperCase() }}
                    -
                    {{ CustomerBalanceDetails[0].customer.contact }}

                    <br>

                    FROM {{ filterRecords.datefrom }}
                    TO {{ filterRecords.dateto }}

                  </strong>

                </h5>

              </div>

            </div>

            <!-- TABLE -->

            <div class="table-responsive">

              <table class="table table-bordered" style="font-size:15px">

                <thead class="table-light">

                  <tr>

                    <th>S/N</th>
                    <th>Date</th>
                    <th>Category</th>
                    <th>Received Via</th>
                    <th>Debit</th>
                    <th>Credit</th>
                    <th>Balance</th>

                  </tr>

                </thead>

                <tbody>

                  <tr v-for="(record, r) in CustomerBalanceDetails" :key="r">

                    <td>{{ r + 1 }}</td>
                    <td>{{ record.date }}</td>
                    <td>{{ record.Category }}</td>
                    <td>{{ record.mode }}</td>
                    <td>{{ record.amountOut.toLocaleString() }}</td>
                    <td>{{ record.amount.toLocaleString() }}</td>
                    <td>{{ record.newbalance }}</td>

                  </tr>

                  <!-- TOTAL DEBIT -->

                  <tr>

                    <td colspan="4"></td>

                    <td><b>Total Debit</b></td>

                    <td></td>

                    <td>
                      <b>
                        {{ totals.totalout ? totals.totalout.toLocaleString() : 0 }}
                      </b>
                    </td>

                  </tr>

                  <!-- TOTAL CREDIT -->

                  <tr>

                    <td colspan="4"></td>

                    <td><b>Total Credit</b></td>

                    <td></td>

                    <td>
                      <b>
                        {{ totals.totalin ? totals.totalin.toLocaleString() : 0 }}
                      </b>
                    </td>

                  </tr>

                  <!-- TOTAL BALANCE -->

                  <tr>

                    <td colspan="4"></td>

                    <td><b>Total Balance</b></td>

                    <td></td>

                    <td>
                      <b>
                        {{
                          (totals.totalout - totals.totalin)
                            ? (totals.totalout - totals.totalin).toLocaleString()
                        : 0
                        }}
                      </b>
                    </td>

                  </tr>

                </tbody>

              </table>

            </div>

          </div>

        </div>

      </div>

    </div>

  </Layout>
</template>